import { PlusOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Empty, Tag } from "antd";
import React from "react";
import Container from "../General/Container/Container";
import { useDispatch, useSelector } from "react-redux";
import MinifiedResultLoading from "./MinifiedResultLoading";
import { setVisibleAddAudienceModal } from "../../store/components/Reports.slice";
import MinifiedResultDashboard from "./MinifiedResultDashboard";
import PersonasResult from "./Personas/PersonasResult";
import useGetChecked from "../../hooks/minified/useGetChecked";
import NoSubPersonasModal from "../ReportBuilder/NoSubscription/NoSubPersonasModal";
import { setPersonasData, setPersonasParams, setResultMode } from "../../store/components/Minified.slice";
import useGetMinifiedResult from "../../hooks/minified/useGetMinifiedResult";
import CustomLayout from "../General/CustomLayout/CustomLayout";

const MinifiedResult = () => {
    const dispatch = useDispatch()
    const {
        targets,
        loadingResult,
        resultMode,
        personasData,
        personasParams,
        loadingPersonasData,
        loadingPersonasImage
    } = useSelector((state) => state.minified)

    const { visiblePersonasModal } = useSelector((state) => state.reports)

    const {
        resultDataObj,
        percent,
        summary,
        recommendedData,
        onChangeAudienceName
    } = useGetMinifiedResult()

    const {
        heActiveKeys,
        setHeActiveKeys,
        aiActiveKeys,
        setAiActiveKeys,
        hasChecked,
        selectedRowKeysHe,
        setSelectedRowKeysHe,
        selectedRowKeysAi,
        setSelectedRowKeysAi
    } = useGetChecked()


    const header = <Container className="minified-result-header dcol fullscreen">
        <Container className="minified-result-header-action drow justify-between">
            <Container className="drow align-center gap-1">
                <Tag className="minified-header-tag label pad-0">Target Audience:</Tag>
                {targets.map((target) => {
                    return <Tag className="oi-tag capitalize">{target}</Tag>
                })}
            </Container>
            <Button
                icon={<PlusOutlined />}
                type="primary"
                disabled={!hasChecked}
                onClick={() => {
                    const allCheckedObj = [...Object.values(selectedRowKeysHe),
                    ...Object.values(selectedRowKeysAi)].reduce((acc, items) => {
                        items.forEach((item) => {
                            if (!acc[item.categoryName]) {
                                const findCategory = resultDataObj.all.find((cat) => cat.discoveredCategory === item.categoryName)
                                if (findCategory) {
                                    acc[item.categoryName] = {
                                        ...findCategory,
                                        children: []
                                    }
                                }
                            }
                            acc[item.categoryName].children.push(item)
                        })
                        return acc
                    }, {})
                    
                    dispatch(setVisibleAddAudienceModal({
                        visible: true,
                        trackKey: "minifiedCreatePackage",
                        toAddNewAudience: Object.values(allCheckedObj).reduce((acc, items) => {
                            const { tempChildren, children } = items
                            acc = acc.concat(tempChildren || children || [])
                            return acc
                        }, []),
                        toAddNewAudienceName: "",
                    }));
                }}
            >Add to Audience Package</Button>
        </Container>
        {personasParams ? <Breadcrumb className="minified-result-header-breadcrumbs">
            <Breadcrumb.Item>
                <Button
                    style={{ padding: 0 }}
                    type="text"
                    onClick={() => {
                        dispatch(setPersonasData(null));
                        dispatch(setPersonasParams(null));
                        dispatch(setResultMode("dashboard"));
                    }}
                >
                    Back
                </Button>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <b className="fs-16 fw-600 c-bg-600">
                    Personas - {personasParams?.name}
                </b>
            </Breadcrumb.Item>
        </Breadcrumb> : null}
    </Container>

    const getToDisplay = () => {
        if (loadingResult) return <MinifiedResultLoading percent={percent} />
        if (resultMode === "dashboard") return <MinifiedResultDashboard
            resultDataObj={resultDataObj}
            summary={summary}
            recommendedData={recommendedData}
            heActiveKeys={heActiveKeys}
            setHeActiveKeys={setHeActiveKeys}
            aiActiveKeys={aiActiveKeys}
            setAiActiveKeys={setAiActiveKeys}
            selectedRowKeysHe={selectedRowKeysHe}
            setSelectedRowKeysHe={setSelectedRowKeysHe}
            selectedRowKeysAi={selectedRowKeysAi}
            setSelectedRowKeysAi={setSelectedRowKeysAi}
            onChangeAudienceName={onChangeAudienceName}
        />
        return <PersonasResult />
    }

    return <CustomLayout className="minified-result" header={header} classNameBody="d-flex-col">
        {getToDisplay()}
        {visiblePersonasModal.visible && <NoSubPersonasModal />}
    </CustomLayout>
}

export default MinifiedResult